module.exports = __webpack_public_path__ + "4c92b74e.png";